import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { whatsAppMessage } from "../../../utils/common";

const NavigationBarSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSignInClick = () => {
    navigate("/login");
    setMobileOpen(false);
  };
  const handleWhatsAppClick = () => {
    whatsAppMessage();
    setMobileOpen(false);
  };

  const navItems = [
    { label: "ABOUT US", route: "/about-us" },
    { label: "SOLUTIONS", route: "/acs-services" },
    { label: "FEATURES", route: "/acs-unqiue-features" },
    { label: "PRODUCTS", route: "/acs-products-showcase" },
    { label: "PHARMACY", isWhatsApp: true },
    { label: "CONTACT", route: "/acs-contact-us" },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavClick = (item) => {
    if (item.isWhatsApp) {
      handleWhatsAppClick();
    } else {
      navigate(item.route);
      setMobileOpen(false);
    }
  };

  const drawer = (
    <Box sx={{ width: 280, bgcolor: "#1f164f", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <Box
          component="img"
          src="/logo.png"
          alt="Logo"
          sx={{
            width: "150px",
            height: "auto",
          }}
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />
        <IconButton onClick={handleDrawerToggle} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List sx={{ px: 2 }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.route;
          return (
            <ListItem
              key={item.label}
              onClick={() => handleNavClick(item)}
              sx={{
                cursor: "pointer",
                borderBottom: isActive
                  ? "3px solid #fff"
                  : "1px solid rgba(255,255,255,0.1)",
                py: 2,
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    sx={{
                      fontFamily: "'Satoshi-Medium', Montserrat",
                      fontWeight: 500,
                      fontSize: "18px",
                      color: "white",
                      letterSpacing: "-1px",
                    }}
                  >
                    {item.label}
                  </Typography>
                }
              />
            </ListItem>
          );
        })}
        <ListItem sx={{ pt: 2 }}>
          <Button
            variant="contained"
            onClick={handleSignInClick}
            fullWidth
            sx={{
              bgcolor: "#201756",
              borderRadius: "10px",
              py: 1.5,
              "&:hover": {
                bgcolor: "#2a1c6a",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Istok_Web-Bold', Montserrat",
                fontWeight: 700,
                fontSize: "18px",
                color: "white",
                letterSpacing: "-0.32px",
              }}
            >
              SIGN IN
            </Typography>
          </Button>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: "#1f164f",
        height: { xs: "auto", md: "90px" },
        boxShadow: "none",
      }}
    >
      <Container maxWidth={false}>
        <Toolbar
          disableGutters
          sx={{
            height: { xs: "70px", md: "62px" },
            mt: { xs: 0, md: "19px" },
            justifyContent: "space-between",
            px: { xs: 2, md: 0 },
          }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <Box
              component="img"
              src="/logo.png"
              alt="Logo"
              sx={{
                width: { xs: "150px", md: "200px" },
                height: "auto",
                cursor: "pointer",
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "1000px",
                gap: 2,
              }}
            >
              {navItems.map((item) => {
                const isActive = location.pathname === item.route;

                return (
                  <Typography
                    key={item.label}
                    onClick={() => {
                      if (item.isWhatsApp) {
                        handleWhatsAppClick();
                      } else {
                        navigate(item.route);
                      }
                    }}
                    variant="h6"
                    component="div"
                    sx={{
                      fontFamily: "'Satoshi-Medium', Montserrat",
                      fontWeight: 500,
                      fontSize: { xs: "14px", md: "20px" },
                      color: "white",
                      textAlign: "center",
                      letterSpacing: "-1px",
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                      mb: 2.5,
                      borderBottom: isActive ? "3px solid #fff" : "none",
                      "&:hover": {
                        opacity: 0.8,
                      },
                    }}
                  >
                    {item.label}
                  </Typography>
                );
              })}

              {/* Sign in Button */}
              <Button
                variant="contained"
                onClick={handleSignInClick}
                sx={{
                  width: "130px",
                  height: "61px",
                  bgcolor: "#201756",
                  borderRadius: "10px",
                  boxShadow: "none",
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "2px",
                    height: "61px",
                    left: 0,
                    top: 0,
                    backgroundColor: "white",
                  },
                  "&:hover": {
                    bgcolor: "#2a1c6a",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'Istok_Web-Bold', Montserrat",
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "white",
                    textAlign: "center",
                    letterSpacing: "-0.32px",
                  }}
                >
                  SIGN IN
                </Typography>
              </Button>
            </Box>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{ color: "white" }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </Container>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        anchor="right"
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 280,
          },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default NavigationBarSection;
